<script setup>
  import { computed, inject } from 'vue'
  import { getRoundColor, getRoundIcon } from '@/services/utils'
  import RoundName from '@/components/RoundName.vue'

  const currents = inject('currents')

  const orderedRounds = computed(() => {
    if (!currents.value.group || !currents.value.group.rounds) {
      return []
    }
    return [...currents.value.group.rounds].sort((a, b) => a.round_number - b.round_number)
  })
</script>


<template>
  <v-list v-if="currents.group?.rounds"
    id="fixtures"
    class="rounded elevation-1 mt-8"
  >
      <v-list-subheader class="justify-center text-uppercase">
        {{ $t('label.fixtures') }}
      </v-list-subheader>

      <template v-if="orderedRounds && orderedRounds.length > 0"
        v-for="(round, index) in orderedRounds"
        :key="index"
      >
        <v-list-item
          :to="{ name: 'tournament-round', params: { round: round.id } }"
          link
        >
          <template v-slot:prepend>
            <v-icon :color="getRoundColor(round.state)">{{ getRoundIcon(round.state) }}</v-icon>
          </template>
          <template #subtitle>
            <RoundName :round="round" />
          </template>
        </v-list-item>
      </template>

      <v-alert
        v-else
        type="info"
        variant="text"
        class="mb-8"
      >
        {{ $t('tournaments.noRounds') }}
      </v-alert>
    
  </v-list>
</template>
